import { useContext } from 'react';
import { BagAuditContext } from './context';

export const useBagAuditContext = () => {
	const context = useContext(BagAuditContext);
	if (!context) {
		throw new Error('useBagAuditContext must be used within a BagAuditContextProvider');
	}
	return context;
};
